const initialState = {
  estado: null
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'NN':
      return {
        ...state,
        estado: action.estado
      }
    default:
      return state
  }
}
